import { api } from "@/lib/api";

const phone = () => {
  try {
    return JSON.parse(localStorage.getItem("vs_customer"))?.phone || "";
  } catch {
    return "";
  }
};

const send = (payload) => {
  const p = phone();
  if (!p) return;
  api.post("/activity", { phone: p, ...payload }).catch(() => {});
};

const sent = new Set();

export const trackSearch = (term) => {
  const clean = term.trim();
  if (clean.length < 2 || sent.has(`s:${clean.toLowerCase()}`)) return;
  sent.add(`s:${clean.toLowerCase()}`);
  send({ type: "search", value: clean });
};

export const trackView = (product) =>
  send({ type: "view", value: product.name, product_id: product.id, sku: product.sku || "" });
